/**
 *
 *  PasswordInput
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 08/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

// Icons
import PasswordHideIcon from "../../icons/PasswordHideIcon";
import PasswordShowIcon from "../../icons/PasswordShowIcon";

export const PasswordInput = React.forwardRef(
  (
    {
      hasError,
      autoComplete = "current-password",
      placeholder,
      minLength,
      maxLength,
      pattern,
      password,
      style,
      onChange,
      ...rest
    },
    outerRef
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordToggle = useCallback(
      (e) => {
        if (showPassword) {
          setShowPassword(false);
        } else {
          setShowPassword(true);
        }
      },
      [showPassword]
    );

    return (
      <div
        className={`tbk-input-field tbk-relative tbk-py-0 tbk-pl-0 focus-within:tbk-border-blue-grey ${
          hasError ? "tbk-border-coral" : ""
        }`}
      >
        <input
          ref={outerRef}
          type={showPassword ? "text" : "password"}
          className="tbk-text-main tbk-w-full tbk-rounded-lg tbk-pt-[11px] tbk-pl-2 tbk-pr-2 tbk-pb-[11px] tbk-outline-none"
          autoComplete={autoComplete}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          pattern={pattern}
          style={style}
          value={password}
          onChange={onChange}
          onInput={onChange}
        />
        <div
          role="button"
          tabIndex={-1}
          className="tbk-absolute tbk-bottom-2 tbk-top-1.5 tbk-right-1.5 tbk-text-coral"
          onClick={handlePasswordToggle}
        >
          {showPassword ? <PasswordHideIcon /> : <PasswordShowIcon />}
        </div>
      </div>
    );
  }
);

PasswordInput.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.string,
  maxLength: PropTypes.string,
  password: PropTypes.string, // value
  onChange: PropTypes.func.isRequired,
};

export default PasswordInput;
